import { render } from "./MainSectionTwo.vue?vue&type=template&id=58ccb333&scoped=true"
import script from "./MainSectionTwo.vue?vue&type=script&lang=js"
export * from "./MainSectionTwo.vue?vue&type=script&lang=js"

import "./MainSectionTwo.vue?vue&type=style&index=0&id=58ccb333&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ccb333"]])

export default __exports__